import React, { Component } from 'react';
import{ Button, Col} from 'reactstrap';
import './Login.css';


export class HomeButton extends Component {

  handleClick = (e) => {
    if(!this.props.off){
        this.props.history.push(this.props.path);
    }
    
  } 

  clickFunction = (e) => {
    if(!this.props.clicked){
      return this.handleClick(e);
    }
    else{
      return this.props.clicked(e.target, this.props.index);
    }
  }

  render () {
    return (
        <Col id="wrapper" className={this.props.classes} style={{padding: '0px', paddingTop: '15px'}}>
            <Button id={this.props.buttonId} style={{padding: '0px', height: '20vh', width: '20vh', backgroundColor: this.props.buttonBackground ? this.props.buttonBackground : 'transparent', border: 'none', borderRadius: '25px'}} onClick={this.clickFunction}>
              <img className={this.props.imgClasses} style={{aspectRatio: 2, height: '100%', width: '100%'}} src={this.props.image} alt={this.props.name}></img>
              {this.props.needsText ? <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>{this.props.name}</div> : null}
            </Button>
        </Col>     
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/HomeButton.js